import { useL10n } from "@ews/react-localization-context";
import { IonButton, IonCol } from "@ionic/react";
import React from "react";
import { useIsMobile } from "../../../../../Responsive";
import style from "../../LicenseSettings.module.scss";
import { InvoiceAddressPopoverProps } from "./types";

export const ButtonContainer: React.FC<
    { invoiceAddressIsFilledOut: boolean, onClick: () => void; } &
    Pick<InvoiceAddressPopoverProps, "onDismiss">
> = ({
    invoiceAddressIsFilledOut,
    onClick,
    onDismiss,
}) =>
    {
        const mobileView = useIsMobile();
        const { translate: t } = useL10n();

        const Wrapper = mobileView ? React.Fragment : IonCol;

        return <>
            {mobileView ? null : <Wrapper>
                <div
                    className={mobileView ? `${style.padding5}` : `${style.center} ${style.width100} ${style.resetPadding} ${style.buttonContainer}`}
                >
                    <IonButton
                        color={"danger"}
                        onClick={() => onDismiss()}
                    >{t("COM_BANNERS_CANCEL")}
                    </IonButton>
                </div>
            </Wrapper>}

            <Wrapper>
                <div
                    className={mobileView ? `${style.padding5}` : `${style.center} ${style.width100} ${style.resetPadding} ${style.spaceAround}`}
                >
                    <IonButton
                        disabled={!invoiceAddressIsFilledOut}
                        color={"success"}
                        expand={mobileView ? "full" : undefined}
                        onClick={onClick}
                    >{t("COM_MAILTO_SEND")}
                    </IonButton>
                </div>
            </Wrapper>
        </>;
    };